<template>
    <div>
        <strong>Términos y condiciones</strong>
        <p>Estos términos y condiciones se aplican a la aplicación Serene (en adelante, la "Aplicación") para
            dispositivos móviles, creada por Quiz & Juegos en línea (en adelante, "Proveedor de servicios") como un
            servicio freemium.</p>
        <br>
        <p>Al descargar o utilizar la Aplicación, usted acepta automáticamente los siguientes términos. Es muy
            recomendable que lea y comprenda estos términos antes de utilizar la Aplicación. Se prohíbe estrictamente la
            copia y modificación no autorizada de la Aplicación, de cualquier parte de la Aplicación o de nuestras
            marcas comerciales. Tampoco se permiten los intentos de extraer el código fuente de la Aplicación,
            traducirlo a otros idiomas o crear versiones derivadas. Todas las marcas comerciales, derechos de autor,
            derechos de bases de datos y otros derechos de propiedad intelectual relacionados con la Aplicación siguen
            siendo propiedad del Proveedor de Servicios.</p>
        <br>
        <p>El Proveedor de Servicios se compromete a garantizar que la Aplicación sea lo más útil y eficiente posible.
            Por lo tanto, se reserva el derecho de modificar la Aplicación o cobrar por sus servicios en cualquier
            momento y por cualquier motivo. El proveedor de servicios garantiza que cualquier cargo por la aplicación o
            sus servicios se le comunique claramente.</p>
        <br>
        <p>La Aplicación almacena y procesa los datos personales que usted ha proporcionado al Proveedor de Servicios
            para prestar el Servicio. Es su responsabilidad mantener la seguridad de su teléfono y el acceso a la
            Aplicación. El proveedor de servicios recomienda encarecidamente que evite realizar jailbreak o rooteo a su
            teléfono, acciones que implican eliminar restricciones de software impuestas por el sistema operativo
            oficial del dispositivo. Estas acciones pueden exponer su teléfono a malware, virus, programas maliciosos,
            comprometer las funciones de seguridad del dispositivo y provocar que la aplicación funcione mal o se vuelva
            completamente inoperable.</p>
        <div>
            <p>La Aplicación utiliza servicios de terceros que tienen sus propios Términos y Condiciones. A continuación
                se muestran enlaces a los Términos y Condiciones de los proveedores de servicios de terceros utilizados
                por la Aplicación:</p>
            <ul>
                <li><a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Servicios de
                        Google Play</a></li>
                <li><a href="https://developers.google.com/admob/terms" target="_blank"
                        rel="noopener noreferrer">AdMob</a></li>
                <li><a href="https://www.google.com/analytics/terms/" target="_blank" rel="noopener noreferrer">Google
                        Analytics para Firebase</a></li>
                <li><a href="https://firebase.google.com/terms/crashlytics" target="_blank"
                        rel="noopener noreferrer">Crashlytics de Firebase</a></li>
                <li><a href="https://onesignal.com/tos" target="_blank" rel="noopener noreferrer">Una Señal</a></li>
                <li><a href="https://www.revenuecat.com/terms" target="_blank" rel="noopener noreferrer">RevenueCat</a>
                </li>
            </ul>
        </div>
        <br>
        <p>El proveedor de servicios no asume ninguna responsabilidad por determinados aspectos. Algunas funciones de la
            Aplicación requieren una conexión a Internet activa, ya sea vía Wi-Fi o proporcionada por su proveedor de
            red móvil. El Proveedor de Servicios no es responsable si la Aplicación no funciona completamente debido a
            la falta de acceso a Wi-Fi o si ha agotado su asignación de datos.</p>
        <br>
        <p>Si utiliza la aplicación fuera de un área Wi-Fi, tenga en cuenta que los términos de su acuerdo con su
            proveedor de red móvil aún se aplican. Es posible que se le apliquen cargos de su proveedor de red móvil por
            el uso de datos mientras esté conectado a la Aplicación, o de otros cargos de terceros. Al utilizar la
            Aplicación, usted acepta la responsabilidad de dichos cargos, incluidos los cargos de roaming si utiliza la
            Aplicación fuera de su región o país sin deshabilitar el roaming de datos. Si no es el propietario de la
            cuenta del dispositivo, asumimos que tiene el permiso del propietario.</p>
        <br>
        <p>Además, el Proveedor de Servicios no siempre puede asumir la responsabilidad por el uso de la Aplicación. Por
            ejemplo, es su responsabilidad asegurarse de que su dispositivo esté cargado. Si su dispositivo se queda sin
            batería y no puede acceder al Servicio, el Proveedor de Servicios no será responsable.</p>
        <br>
        <p>En cuanto a la responsabilidad del Proveedor de Servicios por el uso que usted haga de la Aplicación, es
            importante tener en cuenta que, si bien se esfuerza por mantenerla actualizada y precisa, depende de
            terceros para proporcionar la información que se pone a su disposición. El Proveedor de Servicios no es
            responsable de ninguna pérdida, directa o indirecta, que usted pueda sufrir al confiar enteramente en esta
            funcionalidad de la Aplicación.</p>
        <br>
        <p>El Proveedor de Servicios podrá actualizar la Aplicación de vez en cuando. La Aplicación está actualmente
            disponible sujeta a los requisitos del sistema operativo (y cualquier sistema adicional al que decidan
            extender la disponibilidad de la Aplicación) puede cambiar Necesitará descargar actualizaciones si desea
            seguir usando la aplicación. El Proveedor de Servicios no garantiza que siempre actualizará la Aplicación
            para que sea relevante para usted o compatible con la versión del sistema operativo instalado en su
            dispositivo. Sin embargo, usted acepta aceptar siempre las actualizaciones cuando se le ofrezcan. El
            Proveedor de Servicios también podrá decidir terminar la prestación de la Aplicación y podrá finalizar su
            uso en cualquier momento sin previo aviso. A menos que se indique lo contrario, en caso de terminación, (a)
            los derechos y licencias otorgados a usted en estos Términos terminarán; (b) deberá dejar de usar la
            Aplicación y, si es necesario, eliminarla de su dispositivo.</p>
        <br><strong>Cambios en los Términos y Condiciones</strong>
        <p>El Proveedor de Servicios podrá actualizar periódicamente sus Términos y Condiciones. Por lo tanto, se
            recomienda que revises esta página periódicamente para ver los cambios. El Proveedor de Servicios le
            notificará sobre cualquier cambio publicando los nuevos Términos y Condiciones en esta página.</p>
        <br>
        <p>Estos términos y condiciones son válidos a partir del 12 de enero de 2025.</p>
        <br><strong>Contáctanos</strong>
        <p>Si tiene alguna pregunta o sugerencia sobre los Términos y Condiciones, no dude en ponerse en contacto con el
            Proveedor de Servicios por correo electrónico: quizejogosonline@gmail.com.</p>
    </div>
</template>

<script>
export default {
    name: "SereneTermsAndConditionsES"
}
</script>